import { Download } from "lucide-react";

const FILES = [
  { href: "/demo/placebacker-demo.mp4", label: "Download narrated demo", note: "1:55 · 1080p · H.264/AAC · with captions", testid: "demo-download-narrated" },
  { href: "/demo/placebacker-demo-silent.mp4", label: "Download silent demo", note: "Same cut · captions, no audio", testid: "demo-download-silent" },
];

export default function DemoPage() {
  return (
    <main className="mx-auto max-w-4xl px-5 py-12 sm:px-8 lg:py-20" data-testid="demo-page">
      <p className="eyebrow">PlaceBacker demo</p>
      <h1 className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl">See PlaceBacker in two minutes.</h1>
      <video className="mt-8 w-full rounded-xl bg-[var(--charcoal)]" src={FILES[0].href} controls preload="metadata" playsInline data-testid="demo-video" />
      <div className="mt-6 grid gap-3 sm:grid-cols-2">
        {FILES.map((f) => (
          <a key={f.href} href={f.href} download className="card flex items-center gap-4 p-4 transition-transform hover:-translate-y-0.5" data-testid={f.testid}>
            <span className="grid h-11 w-11 place-items-center rounded-full bg-[var(--green)] text-white"><Download size={18} /></span>
            <span><span className="block font-semibold">{f.label}</span><span className="block text-xs text-[var(--stone-dark)]">{f.note}</span></span>
          </a>
        ))}
      </div>
    </main>
  );
}
